(function () {
  var openModal = null;

  // Move modals to <body> so `position: fixed` is relative to the viewport,
  // not trapped inside a transformed/sticky ancestor (e.g. the centered info column).
  var modals = document.querySelectorAll('[data-size-guide-modal]');
  for (var m = 0; m < modals.length; m++) {
    document.body.appendChild(modals[m]);
  }

  function open(modal) {
    if (openModal) close(openModal);
    modal.hidden = false;
    document.documentElement.style.overflowY = 'hidden';
    openModal = modal;
    var closeBtn = modal.querySelector('[data-size-guide-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close(modal) {
    modal.hidden = true;
    document.documentElement.style.overflowY = '';
    if (openModal === modal) openModal = null;
  }

  function switchTab(modal, unit) {
    var tabs = modal.querySelectorAll('[data-size-guide-tab]');
    var panels = modal.querySelectorAll('[data-size-guide-panel]');

    for (var i = 0; i < tabs.length; i++) {
      var isActive = tabs[i].getAttribute('data-size-guide-tab') === unit;
      tabs[i].classList.toggle('is-active', isActive);
      tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }
    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].getAttribute('data-size-guide-panel') !== unit;
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-size-guide-open'));
      if (modal) open(modal);
      return;
    }

    var closer = event.target.closest('[data-size-guide-close]');
    if (closer) {
      var modalToClose = closer.closest('[data-size-guide-modal]');
      if (modalToClose) close(modalToClose);
      return;
    }

    var tab = event.target.closest('[data-size-guide-tab]');
    if (tab) {
      var modalForTab = tab.closest('[data-size-guide-modal]');
      if (modalForTab) switchTab(modalForTab, tab.getAttribute('data-size-guide-tab'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openModal) close(openModal);
  });
})();
